/**
 * What may change on a running outreach agent.
 *
 * Queue entries store a step index. Adding, removing or reordering steps would
 * point those contacts at the wrong action. Settings on a step (ICP, template,
 * score, wait days, …) can change — the next process cycle reads the job live.
 */

export const LIVE_EDITABLE_STATUSES = new Set(['active', 'paused']);

export const isLiveJob = (job) => !!(job && LIVE_EDITABLE_STATUSES.has(job.status));

export const stepStructureKey = (steps) => (Array.isArray(steps) ? steps : [])
  .map((s, i) => `${(s && s.id) || i}:${(s && s.type) || ''}`)
  .join('|');

export const sameStepStructure = (current, next) => (
  stepStructureKey(current) === stepStructureKey(next)
);
